(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bruma-beneficios"] && !Shopify.designMode) return;
  try {
    
class BrumaBeneficios extends HTMLElement {
  connectedCallback() {
    this.items = [...this.querySelectorAll('.bruma-beneficios__ring-wrap')];

    if (!('IntersectionObserver' in window)) {
      this.items.forEach((item) => this.fill(item));
      return;
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.fill(entry.target);
          this.observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });

    this.items.forEach((item) => this.observer.observe(item));
  }

  fill(item) {
    const circle = item.querySelector('.bruma-beneficios__ring-fill');
    if (!circle) return;
    circle.style.strokeDashoffset = item.dataset.offset;
  }
}
customElements.define('bruma-beneficios', BrumaBeneficios);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bruma-ciencia"] && !Shopify.designMode) return;
  try {
    
class BrumaCiencia extends HTMLElement {
  connectedCallback() {
    this.slides  = [...this.querySelectorAll('.bruma-ciencia__slide')];
    this.dots    = [...this.querySelectorAll('.bruma-ciencia__dot')];
    this.prevBtn = this.querySelector('.bruma-ciencia__btn--prev');
    this.nextBtn = this.querySelector('.bruma-ciencia__btn--next');
    this.index   = 0;

    this.prevBtn?.addEventListener('click', () => this.move(-1));
    this.nextBtn?.addEventListener('click', () => this.move(1));
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));

    this.update();
  }

  move(dir) {
    this.goTo(this.index + dir);
  }

  goTo(i) {
    const total = this.slides.length;
    if (i < 0 || i >= total) return;
    this.slides[this.index].classList.remove('is-active');
    this.index = i;
    this.slides[this.index].classList.add('is-active');
    this.update();
  }

  update() {
    const total = this.slides.length;
    this.prevBtn?.toggleAttribute('disabled', this.index <= 0);
    this.nextBtn?.toggleAttribute('disabled', this.index >= total - 1);
    this.dots.forEach((dot, i) => {
      const active = i === this.index;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }
}
customElements.define('bruma-ciencia', BrumaCiencia);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bruma-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.bruma-faq__question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = this.closest('.bruma-faq__item');
      var answer = document.getElementById(this.getAttribute('aria-controls'));
      var isOpen = item.classList.contains('bruma-faq__item--open');

      if (isOpen) {
        item.classList.remove('bruma-faq__item--open');
        this.setAttribute('aria-expanded', 'false');
        answer.hidden = true;
      } else {
        item.classList.add('bruma-faq__item--open');
        this.setAttribute('aria-expanded', 'true');
        answer.hidden = false;
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bruma-producto-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.bruma-hero__swatch').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var targetId = this.dataset.nameTarget;
      var nameEl = document.getElementById(targetId);
      var parent = this.closest('.bruma-hero__swatches');

      parent.querySelectorAll('.bruma-hero__swatch').forEach(function (s) {
        s.classList.remove('is-active');
        s.setAttribute('aria-pressed', 'false');
      });

      this.classList.add('is-active');
      this.setAttribute('aria-pressed', 'true');

      if (nameEl) nameEl.textContent = this.dataset.colorName;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bruma-producto-mobile"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.bpm__swatch').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var targetId = this.dataset.nameTarget;
      var nameEl   = document.getElementById(targetId);
      var parent   = this.closest('.bpm__swatches');

      parent.querySelectorAll('.bpm__swatch').forEach(function (s) {
        s.classList.remove('is-active');
        s.setAttribute('aria-pressed', 'false');
      });

      this.classList.add('is-active');
      this.setAttribute('aria-pressed', 'true');
      if (nameEl) nameEl.textContent = this.dataset.colorName;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bruma-resenas"] && !Shopify.designMode) return;
  try {
    
class BrumaResenas extends HTMLElement {
  connectedCallback() {
    this.track    = this.querySelector('.bruma-resenas__track');
    this.cards    = [...this.querySelectorAll('.bruma-resenas__card')];
    this.dots     = [...this.querySelectorAll('.bruma-resenas__dot')];
    this.prevBtn  = this.querySelector('.bruma-resenas__btn--prev');
    this.nextBtn  = this.querySelector('.bruma-resenas__btn--next');
    this.index    = 0;

    this.prevBtn?.addEventListener('click', () => this.move(-1));
    this.nextBtn?.addEventListener('click', () => this.move(1));
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));
    this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });

    this.update();
  }

  visibleCount() {
    const w = window.innerWidth;
    const columns = parseInt(this.dataset.columns, 10) || 3;
    return w >= 990 ? columns : w >= 750 ? Math.min(columns, 2) : 1;
  }

  cardStep() {
    const card = this.cards[0];
    if (!card) return 0;
    const gap = parseFloat(getComputedStyle(this.track).gap) || 20;
    return card.offsetWidth + gap;
  }

  move(dir) {
    this.track.scrollBy({ left: this.cardStep() * dir, behavior: 'smooth' });
  }

  goTo(i) {
    this.track.scrollTo({ left: this.cardStep() * i, behavior: 'smooth' });
  }

  onScroll() {
    const step = this.cardStep();
    this.index = step > 0 ? Math.round(this.track.scrollLeft / step) : 0;
    this.update();
  }

  update() {
    const max = this.cards.length - this.visibleCount();
    this.prevBtn?.toggleAttribute('disabled', this.index <= 0);
    this.nextBtn?.toggleAttribute('disabled', this.index >= max);
    this.dots.forEach((dot, i) => {
      const active = i === this.index;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }
}
customElements.define('bruma-resenas', BrumaResenas);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
